/*
 * Copyright (c) 2020. American Express Company
 */

import { LocalDateTime } from '@js-joda/core';
import { BalanceModel } from './balance.model';
import { IncomeModel } from './income.model';
import { TransactionModel } from './transaction.model';

export class InstitutionModel {
    id!: number;
    institutionId!: string;
    accessToken!: string;
    name!: string;
    balances!: BalanceModel[];
    incomes!: IncomeModel[];
    transactions!: TransactionModel[];
    loginRequired!: boolean;
    created: LocalDateTime;
    updated: LocalDateTime;
    syncStatus: SyncStatus;
}

export enum SyncStatus {
    LoginRequired = 'LOGIN_REQUIRED'
}
